var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.confirmData,
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "房间号" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.confirmData.houseCode,
                      callback: function($$v) {
                        _vm.$set(_vm.confirmData, "houseCode", $$v)
                      },
                      expression: "confirmData.houseCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户姓名" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.confirmData.customerName,
                      callback: function($$v) {
                        _vm.$set(_vm.confirmData, "customerName", $$v)
                      },
                      expression: "confirmData.customerName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "收费总计" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.confirmData.totalAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.confirmData, "totalAmount", $$v)
                      },
                      expression: "confirmData.totalAmount"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "收款时间" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.confirmData.receiptDate,
                      callback: function($$v) {
                        _vm.$set(_vm.confirmData, "receiptDate", $$v)
                      },
                      expression: "confirmData.receiptDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { "margin-bottom": "10px" }, attrs: { span: 24 } },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { label: "收费项目汇总", name: "first" }
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.confirmData.decorateStandardInfoVos,
                            "element-loading-text": "数据正在加载中...",
                            border: "",
                            stripe: "",
                            fit: "",
                            "highlight-current-row": ""
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: _vm.$t("table.id"),
                              width: "50"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "费用项目" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.chargeItemName))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "起始日期" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.beginDate))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "结束日期" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.endDate))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "收费金额(元)" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.amount))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "收费明细", name: "second" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.confirmData.decorateStandardInfoVos,
                            "element-loading-text": "数据正在加载中...",
                            border: "",
                            stripe: "",
                            fit: "",
                            "highlight-current-row": ""
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "费用项目",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.chargeItemName))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "收费标准",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(scope.row.chargeStandardName)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "建筑面积(m²)" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.houseUseArea))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c(
                            "el-table-column",
                            { attrs: { align: "center", label: "仪表" } },
                            [
                              _c("el-table-column", {
                                attrs: { align: "center", label: "上期读数" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.lastReas))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "本期读数" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.currentRead))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "倍率" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.ratio))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "用量" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.meterUse))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "单价(元)" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.price))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "收费金额(元)"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.amount))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "减免金额(元)"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.reductionAmount)
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "起始日期" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.beginDate))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "截止日期" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.endDate))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "备注" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.remark))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("h3", [_vm._v("付款方式")]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.confirmData.chargeTypeList,
                "element-loading-text": "数据正在加载中...",
                border: "",
                stripe: "",
                fit: "",
                "highlight-current-row": ""
              },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "付款方式" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.paymentMethodName))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "付款金额(元)" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.amount))])]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("h3", [_vm._v("票据")]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.confirmData.billAndStandardListVos }
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: props.row.decorateStandardInfoVos,
                              "element-loading-text": "数据正在加载中...",
                              border: "",
                              stripe: "",
                              fit: "",
                              "highlight-current-row": ""
                            },
                            on: {
                              "selection-change": _vm.handleSelectionChange
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "费用项目",
                                "show-overflow-tooltip": ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.chargeItemName)
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "收费标准",
                                "show-overflow-tooltip": ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.chargeStandardName)
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "建筑面积" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.houseArea))
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "上期读数" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.lastReas))
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "本期读数" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.currentRead))
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "用量" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.meterUse))
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "单价" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.price))
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "收费金额" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.amount))
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "起始日期" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.beginDate))
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "截止日期" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.endDate))
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { align: "center", label: "备注" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.remark))
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "140px",
                  label: "票据本名称",
                  prop: "billName"
                }
              }),
              _c("el-table-column", {
                attrs: { label: "票据号", prop: "billNumber" }
              }),
              _c("el-table-column", {
                attrs: { label: "客户姓名", prop: "customerName" }
              }),
              _c("el-table-column", {
                attrs: { label: "资源代码", prop: "houseCode" }
              }),
              _c("el-table-column", {
                attrs: { label: "付款方式", prop: "paymentMethod" }
              }),
              _c("el-table-column", {
                attrs: { label: "收款时间", prop: "receiptDate" }
              }),
              _c("el-table-column", {
                attrs: { label: "金额小计(元)", prop: "totalAmount" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "margin-top": "20px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handUpdate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }